'use strict'

/**
 * @typedef {import('./core/types').FormatOptions} FormatOptions
 */

module.exports = require('./core')
